// Home page Blog Post Scroll

$("#shopify-section-template--16021319614604__1637051712ecdc7476 .halo-row").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots :true,
  rtl: window.rtl_slick,
  touchThreshold: 50,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})